import type { RouteRecordRaw } from 'vue-router'

export const analyticsRoutes: RouteRecordRaw[] = [
  {
    path: 'analytics',
    component: () => import('./layouts/AnalyticsLayout.vue'),
    meta: {
      requires: { permissions: 'analytics.app.access' },
    },
    children: [
      {
        path: '',
        name: 'analytics',
        redirect: { name: 'analytics-coverage' },
      },
      {
        path: 'coverage',
        name: 'analytics-coverage',
        component: () => import('./views/CoverageView.vue'),
      },
      {
        path: 'top-assets',
        name: 'analytics-top-assets',
        component: () => import('./views/TopAssetsView.vue'),
      },
      {
        path: 'geography',
        name: 'analytics-geography',
        component: () => import('./views/GeographyView.vue'),
      },
      {
        path: 'traffic-sources',
        name: 'analytics-traffic-sources',
        component: () => import('./views/TrafficSourcesView.vue'),
      },
      {
        path: 'reviews',
        name: 'analytics-reviews',
        component: () => import('./views/ReviewsView.vue'),
      },
      {
        path: 'video-heatmap',
        name: 'analytics-video-heatmap',
        component: () => import('./views/VideoHeatmapView.vue'),
      },
      {
        path: 'viewers',
        name: 'analytics-viewers',
        component: () => import('./views/ViewersStatsView.vue'),
      },
    ],
  },
]

export default analyticsRoutes
